export default {"src":"/_next/static/media/temple_64.299bbe87.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};